import React, { useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import Form from 'react-bootstrap/Form';
import { SpanError, SpanMessage } from './Elements';
import FooterContainer from '../containers/FooterContainer';
import { getUnixTime } from 'date-fns';
import useConfig from '../hooks/useConfig';
import { addSale } from '../firebase/firebaseOps';
import { Button, Container } from 'react-bootstrap';
import './SaleForm.css'; 

const SaleForm = () => {
    const [formData, setFormData] = useState({
        description: '',
        amount: '',
        place: '',
        type: '',
        payment: '',
        startDate: new Date(),
    });
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);

    const { usuario } = useAuth();
    const config = useConfig();

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setIsDisabled(false);
        setMessage('');
        setFormData((prevData) => ({
            ...prevData,
            [name]: name === 'amount' ? value.replace(/[^0-9.]/g, '') : value,
        }));
    }, []);


    const handleSubmit = useCallback((e) => {
        const validateForm = () => {
            const { description, amount, place, type } = formData;
            return description !== '' && amount !== '' && place !== '' && type !== '';
        };

        setIsDisabled(true);
        e.preventDefault();
        const { description, amount, place, type, payment, startDate } = formData;
        let tempAmount = parseFloat(amount).toFixed(2);

        if (validateForm()) {
            if (tempAmount) {
                addSale({
                    description,
                    amount: tempAmount,
                    date: getUnixTime(startDate),
                    userId: usuario.uid,
                    type,
                    place,
                    payment,
                })
                    .then(() => {
                        setFormData({
                            description: '',
                            amount: '',
                            place: '',
                            type: '',
                            payment: '',
                            startDate: new Date(),
                        });
                        setError(false);
                        setMessage('La venta fue agregada correctamente.');
                        setIsDisabled(false);
                    })
                    .catch((error) => {
                        setError(true);
                        setMessage('Hubo un problema al intentar agregar tu venta.');
                        setIsDisabled(false);
                    });
            } else {
                setError(true);
                setMessage('El valor que ingresaste no es correcto.');
                setIsDisabled(false);
            }
        } else {
            setError(true);
            setMessage('Por favor rellena todos los campos.');
            setIsDisabled(false);
        }
    }, [formData, usuario]);

    return (
        <>
            <h1 className="header-margin">Venta</h1>
            <Form onSubmit={handleSubmit}>
                <Container className="form-container">
                    <Form.Control 
                        className="form-control"
                        type="text"
                        name="description"
                        placeholder="Descripción"
                        value={formData.description}
                        onChange={handleChange}
                    />
                    <Form.Control 
                        className="form-control"
                        type="date" 
                        name="startDate"
                        value={formData.startDate.toISOString().split('T')[0]}
                        onChange={(e) => setFormData((prevData) => ({
                            ...prevData,
                            startDate: new Date(e.target.value),
                        }))}
                    />
                    <Form.Select 
                        name="type" 
                        size='lg' 
                        className="form-select" 
                        onChange={handleChange} 
                        value={formData.type}
                    >
                        <option value="" disabled>Categoría</option>
                        {config && config[0]?.categories?.map((e, idx) => (
                            <option key={idx} value={e}>{e}</option>
                        ))}
                    </Form.Select>
                    <Form.Select 
                        name='payment' 
                        size='lg' 
                        className="form-select" 
                        onChange={handleChange} 
                        value={formData.payment}
                    >
                        <option value="" disabled>Tipo de Pago</option>
                        <option value="Efectivo">Efectivo</option>
                        <option value="Sinpe">Sinpe</option>
                        <option value="Tarjeta">Tarjeta</option>
                        <option value="Transferencia">Transferencia</option>
                    </Form.Select>
                    <Form.Select 
                        name="place" 
                        size='lg' 
                        className="form-select" 
                        onChange={handleChange} 
                        value={formData.place}
                    >
                        <option value="" disabled>Lugar de Venta</option>
                        {config && config[0]?.places?.map((e, idx) => (
                            <option key={idx} value={e}>{e}</option>
                        ))}
                    </Form.Select>
                    <Form.Control 
                        className="form-control"
                        type="tel"
                        name="amount"
                        placeholder="₡0.00"
                        value={formData.amount}
                        onChange={handleChange}
                    />
                </Container>
                <div>
                    {error ? <SpanError><strong>{message}</strong></SpanError> : <SpanMessage><strong>{message}</strong></SpanMessage>}
                </div>
                <div>
                    <Button type="submit" size='lg' className="button-submit" disabled={isDisabled}>
                        {'Agregar Venta'}
                    </Button>
                </div>
            </Form>
            <FooterContainer></FooterContainer>
        </>
    );
}

export default SaleForm;